import { render, staticRenderFns } from "./ApplySucess.vue?vue&type=template&id=5597e4a3&scoped=true"
import script from "./ApplySucess.vue?vue&type=script&lang=js"
export * from "./ApplySucess.vue?vue&type=script&lang=js"
import style0 from "./ApplySucess.vue?vue&type=style&index=0&id=5597e4a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5597e4a3",
  null
  
)

export default component.exports